module.exports = __webpack_public_path__ + "img/privacy1.41fe8ff3.png";